var lge = navigator.language.split('-')[0]

lge = localStorage.getItem("lang");

if (lge === "") {
  lge = "zh";
}
const lgDir = {
  首页: {
    en: "Home",
    zh: "首页",
    ft: "首頁",
  },
  快捷搜索: {
    en: "Search",
    zh: "快捷搜索",
    ft: "快捷搜索",
  },
  目录查询: {
    en: "Search",
    zh: "目录查询",
    ft: "目錄查詢",
  },
  车型查询: {
    en: "Model",
    zh: "车型查询",
    ft: "車型查詢",
  },
  零件号查询: {
    en: "Part",
    zh: "零件号查询",
    ft: "零件號查詢",
  },
  品牌件查询: {
    en: "Article",
    zh: "品牌件查询",
    ft: "品牌件查詢",
  },
  维修查询: {
    en: "Maintenance",
    zh: "维修查询",
    ft: "維修查詢",
  },
  操作指引: {
    en: "Help",
    zh: "操作指引",
    ft: "操作指引",
  },
  指引: {
    en: "Help",
    zh: "指引",
    ft: "指引",
  },
  个人中心: {
    en: "Account",
    zh: "个人中心",
    ft: "個人中心",
  },
  我的: {
    en: "Account",
    zh: "我的",
    ft: "我的",
  },
  登录: {
    en: "Log In",
    zh: "登录",
    ft: "登陸",
  },
  注册: {
    en: "Sign up",
    zh: "注册",
    ft: "註冊",
  },
  手机号或邮箱: {
    en: "Phone or Email",
    zh: "手机号或邮箱",
    ft: "手機號或郵箱",
  },
  密码: {
    en: "Password",
    zh: "密码",
    ft: "密碼",
  },
  记住密码: {
    en: "Remember me",
    zh: "记住密码",
    ft: "記住密碼",
  },
  忘记密码: {
    en: "Forgot password",
    zh: "忘记密码",
    ft: "忘記密碼",
  },
  没有账号: {
    en: "New to 007",
    zh: "没有账号",
    ft: "沒有賬號",
  },
  立即注册: {
    en: " Sign up now",
    zh: "立即注册",
    ft: "立即註冊",
  },
  零零汽当前覆盖品牌: {
    en: "007vin Covering Brands",
    zh: "零零汽当前覆盖品牌",
    ft: "零零汽當前覆蓋品牌",
  },
  车型数据: {
    en: "Models",
    zh: "车型数据",
    ft: "車型數據",
  },
  覆盖品牌: {
    en: "Brands",
    zh: "覆盖品牌",
    ft: "覆蓋品牌",
  },
  零件数据: {
    en: "Parts",
    zh: "零件数据",
    ft: "零件數據",
  },
  关于我们: {
    en: "About Us",
    zh: "关于我们",
    ft: "關於我們",
  },
  用户协议: {
    en: "User Agreement",
    zh: "用户协议",
    ft: "用戶協議",
  },
  版权所有: {
    en: "Copy Right",
    zh: "版权所有",
    ft: "版權所有",
  },
  数据合作: {
    en: "Cooperation",
    zh: "数据合作",
    ft: "數據合作",
  },
  密码重置: {
    en: "Password Reset",
    zh: "密码重置",
    ft: "密碼重置",
  },
  选择方式 : {
    en: "Select",
    zh: "选择方式 ",
    ft: "選擇方式",
  },
  手机号: {
    en: "Phone",
    zh: "手机号",
    ft: "手機號",
  },
  邮箱: {
    en: "Email",
    zh: "邮箱",
    ft: "郵箱",
  },
  验证码: {
    en: "Verification code",
    zh: "验证码",
    ft: "驗證碼"
  },
  发送验证码: {
    en: "Get code",
    zh: "发送验证码",
    ft: "發送驗證碼",
  },
  提交: {
    en: "Submit",
    zh: "提交",
    ft: "提交",
  },
  s后再试: {
    en: "s wait",
    zh: "s后再试",
    ft: "s後再試",
  },
  新密码: {
    en: "New password",
    zh: "新密码",
    ft: "新密碼",
  },
  重复新密码: {
    en: "Repeat new password",
    zh: "重复新密码",
    ft: "重複新密碼",
  },
  短号查询品牌: {
    en: 'Short Brand Query',
    zh: '短号查询品牌',
    ft: "短號查詢品牌",
  },

  //vin页面
  全部品牌: {
    en: "All",
    zh: "全部品牌",
    ft: "全部品牌",
  },
  车架号查询: {
    en: "VIN",
    zh: "车架号查询",
    ft: "車架號查詢",
  },
  车架号: {
    en: "VIN",
    zh: "车架号",
    ft: "車架號",
  },
  保养件查询: {
    zh: '保养件查询',
    en: 'Maintenance',
    ft: '保養件查詢',
  },
  选择主组: {
    en: "Main group",
    zh: "选择主组",
    ft: "選擇主組",
  },
  选择分组: {
    en: "Secondary group",
    zh: "选择分组",
    ft: "選擇分組",
  },
  车辆配置: {
    en: "ID",
    zh: "车辆配置",
    ft: "車輛配置",
  },
  "同类车型图片, 仅供参考": {
    en: "Reference picture",
    zh: "同类车型图片, 仅供参考",
    ft: "同類車型圖片，僅供參考",
  },
  "输入零件原厂名/零件号": {
    en: "OE number/ Part name",
    zh: "输入零件原厂名/零件号",
    ft: "輸入零件原廠名/零件號",
  },
  "输入零件号／故障码": {
    en: "OE number/SDC code",
    zh: "输入零件号／故障码",
    ft: "輸入零件號/故障碼",
  },
  "输入零件号／工程编号": {
    en: "OE number/Eng Pid",
    zh: "输入零件号／工程编号",
    ft: "輸入零件號",
  },
  搜索结果: {
    en: "Search Result",
    zh: "搜索结果",
    ft: "搜索結果",
  },
  搜索: {
    en: "Search",
    zh: "搜索",
    ft: "搜索",
  },
  零件搜索: {
    en: "Part Search",
    zh: "零件搜索",
    ft: "零件搜索",
  },
  重新输入: {
    en: "Retry",
    zh: "重新输入",
    ft: "重新輸入",
  },
  零零汽为您找到: {
    en: "Find results for you ",
    zh: "零零汽为您找到",
    ft: "零零汽為您找到",
  },
  相关结果: {
    en: "Related results",
    zh: "相关结果",
    ft: "相關結果",
  },
  建议您: {
    en: "suggest you",
    zh: "建议您",
    ft: "建議您",
  },
  重新查询: {
    en: "Retry",
    zh: "重新查询",
    ft: "重新查詢",
  },
  输入17位VIN车架号: {
    en: "17 VIN",
    zh: "输入17位VIN车架号",
    ft: "輸入17位VIN車架號",
  },
  "输入主组图号/名称": {
    en: "Try model inquiry",
    zh: "输入主组图号/名称",
    ft: "輸入主組圖號/名稱",
  },
  上一步: {
    en: "Back",
    zh: "上一步",
    ft: "上一步",
  },
  返回上一步: {
    en: "go back",
    zh: "返回上一步",
    ft: "返回上一步",
  },
  前往下一步: {
    en: "go forward",
    zh: "前往下一步",
    ft: "前往下一步",
  },
  分组: {
    en: "SG",
    zh: "分组",
    ft: "分組",
  },
  返回分组选择: {
    en: "subgroup",
    zh: "返回分组选择",
    ft: "返回分組選擇",
  },
  配置: {
    en: "ID",
    zh: "配置",
    ft: "配置",
  },
  车辆配置信息: {
    en: "Vehicle ID",
    zh: "车辆配置信息",
    ft: "車輛配置信息",
  },
  过滤: {
    en: "Filter",
    zh: "过滤",
    ft: "過濾",
  },
  未过滤: {
    en: "Unfilter",
    zh: "未过滤",
    ft: "未過濾",
  },
  上一主组: {
    en: "Prev.",
    zh: "上一主组",
    ft: "上一主組",
  },
  下一主组: {
    en: "Next",
    zh: "下一主组",
    ft: "下一主組",
  },
  上一组: {
    en: "Prev.",
    zh: "上一组",
    ft: "上一組",
  },
  下一组: {
    en: "Next",
    zh: "下一组",
    ft: "下一組",
  },
  "上/下主组": {
    en: "MG",
    zh: "上/下主组",
    ft: "上/下主組",
  },
  "上/下分组": {
    en: "SG",
    zh: "上/下分组",
    ft: "上/下分組",
  },
  "上/下组": {
    en: "SG",
    zh: "上/下组",
    ft: "上/下組",
  },
  上一分组: {
    en: "Prev.",
    zh: "上一分组",
    ft: "上一分組",
  },
  下一分组: {
    en: "Next",
    zh: "下一分组",
    ft: "下一分組",
  },
  无此零件: {
    en: "Not Find",
    zh: "无此零件",
    ft: "無此零件",
  },
  编辑: {
    en: "Edit",
    zh: "编辑",
    ft: "編輯",
  },
  以上信息仅供参考: {
    en: "The above information is provided by 007vin, for reference only！",
    zh: "以上信息仅供参考",
    ft: "以上信息僅供參考",
  },
  已到最后一主组: {
    en: "Has reached the last group",
    zh: "已到最后一主组",
    ft: "已到最後一主組",
  },
  已到最后一分组: {
    en: "Has reached the last group",
    zh: "已到最后一分组",
    ft: "已到最後一分組",
  },
  已到最后一组: {
    en: "Has reached the last group",
    zh: "已到最后一组",
    ft: "已到最後一組",
  },
  已到第一组: {
    en: "Has reached the first group",
    zh: "已到第一组",
    ft: "已到第一組",
  },
  已到第一分组: {
    en: "Has reached the first group",
    zh: "已到第一分组",
    ft: "已到第一分組",
  },
  已到第一主组: {
    en: "Has reached the first group",
    zh: "已到第一主组",
    ft: "已到第一主組",
  },
  "红色字体：非此车架号的分组（参照原厂数据）": {
    en: "Red indicates: Subgroups are not original from this VIN(Reference: data provided by manufacturer)",
    zh: "红色字体：非此车架号的分组（参照原厂数据）",
    ft: "紅色字體：非此車架號的分組（參照原廠數據）",
  },
  "红色字体：非此车架号的零件（参照原厂数据）": {
    en: "Red indicates:Parts are not original from this VIN(Reference: data provided by manufacturer) ",
    zh: "红色字体：非此车架号的零件（参照原厂数据）",
    ft: "紅色字體：非此車架號的零件（參照原廠數據）",
  },
  "绿色字体：匹配条件过滤": {
    en: "Green font:Specification condition filtering(can select)",
    zh: "绿色字体：规格条件过滤（表示可选）",
    ft: "綠色字體：規格條件過濾（表示可選）",
  },
  "网络超时，以下为基础零件数据。": {
    en: "Network time out, follwing part list is composed by fundamental parts only.",
    zh: "网络超时，以下为基础零件数据。",
    ft: "網絡超時，以下為基礎零件數據",
  },
  未搜索到相关结果: {
    en: "Can't find results for you",
    zh: "未搜索到相关结果",
    ft: "未搜索到相關結果",
  },
  复制: {
    en: "Copy",
    zh: "复制",
    ft: "複製",
  },
  复制成功: {
    en: "copied",
    zh: "复制成功",
    ft: "複製成功",
  },
  查看: {
    en: "View",
    zh: "查看",
    ft: "查看",
  },
  添加购物车: {
    en: "Add to cart",
    zh: "添加购物车",
    ft: "添加購物車",
  },
  已添加至购物车: {
    en: "added",
    zh: "已添加至购物车",
    ft: "已添加至購物車",
  },
  含替换件: {
    en: "Supersession",
    zh: "含替换件",
    ft: "含替換件",
  },
  含组件: {
    en: "Component",
    zh: "含组件",
    ft: "含組件",
  },
  "含替换件、组件": {
    en: "Component、Article",
    zh: "含替换件、组件",
    ft: "含替換件、組件",
  },
  留言: {
    en: "Leave Message",
    zh: "留言",
    ft: "留言",
  },
  热门搜索: {
    en: "Search Trending",
    zh: "热门搜索",
    ft: "熱門搜索",
  },
  以图片方式显示: {
    en: "Show item as icon",
    zh: "以图片方式显示",
    ft: "以圖片方式顯示",
  },
  以列表方式显示: {
    en: "Show item as list",
    zh: "以列表方式显示",
    ft: "以列表方式顯示",
  },
  含品牌件: {
    en: "Article",
    zh: "含品牌件",
    ft: "含品牌件",
  },
  error17: {
    en: "Sorry, the VIN you entered is less than <span>17</span> digist.",
    zh: "抱歉，您输入的车架号不足<span>17</span>位。",
    ft: "抱歉，您輸入的車架號不足<span>17</span>位。",
  },
  error8to17: {
    en: "Sorry, the VIN you entered is not <span>8</span> or <span>17</span>digist.",
    zh: "抱歉，您输入的车架号不是<span>8</span>或<span>17</span>位。",
    ft: "抱歉，您輸入的車架號不是<span>8</span>或<span>17</span>位。",
  },
  error7to17: {
    en: "Sorry, the VIN you entered is not <span>7</span> or <span>17</span>digist",
    zh: "抱歉，您输入的车架号不是<span>7</span>或<span>17</span>位。",
    ft: "抱歉，您輸入的車架號不是<span>7</span>或<span>17</span>位。",
  },
  mainGroupTitle: {
    en: "Maingroup(   )",
    zh: "主组(   组)",
    ft: "主組(   組)",
  },
  subGroupTitle: {
    en: "Subgroup(   )",
    zh: "选择分组(共   组)",
    ft: "選擇分組(共   組)",
  },
  searchResultTitle: {
    en: "Search Result(   )",
    zh: " 搜索结果（共   组）",
    ft: " 搜索結果（共   組）",
  },
  subTableHeader: {
    en: ["MG", "SG", "ILL-No", "Description", "Remark", "Model"],
    zh: ["主组","分组","图号","名称","备注","型号"],
    ft: ["主組","分組","圖號","名稱","備註","型號"],
  },
  partListHeader: {
    en: ['', 'POS', 'OE Number', 'Name', 'QTY', 'Model', 'Remark', 'Price', '', '', ""],
    zh: ['', '位置', '零件OE号', '名称', '件数', '型号', '备注', '参考价格', '说明', '', ""],
    ft: ['', '位置', '零件OE號', '名稱', '件數', '型號', '備註', '參考價格', '說明', '', ""],
  },
  //car车型
  选择主组信息: {
    en: "Maingroup",
    zh: "选择主组信息",
    ft: "選擇主組信息",
  },
  输入搜索内容: {
    en: "Search",
    zh: "输入搜索内容",
    ft: "輸入搜索內容",
  },
  "(共   组)": {
    en: "(   )",
    zh: "(共   组)",
    ft: "(共   組)",
  },

  //part
  默认查询品牌: {
    en: "Default",
    zh: "默认查询品牌",
    ft: "默認查詢品牌",
  },
  设为默认: {
    en: "Set as Default",
    zh: "设为默认",
    ft: "設為默認",
  },
  选择品牌: {
    en: "Brand",
    zh: "选择品牌",
    ft: "選擇品牌",
  },
  全部: {
    en: "All",
    zh: "全部",
    ft: "全部",
  },
  查询: {
    en: "Search",
    zh: "查询",
    ft: "查詢",
  },
  查询历史: {
    en: "Query history",
    zh: "查询历史",
    ft: "查詢歷史",
  },
  更多历史: {
    en: "More History",
    zh: "更多历史",
    ft: "更多歷史",
  },
  关闭: {
    en: "Close",
    zh: "关闭",
    ft: "關閉",
  },
  输入完整零件号: {
    en: "OE number",
    zh: "输入完整零件号",
    ft: "輸入完整零件號",
  },
  故障码: {
    en: "SDC Code",
    zh: "故障码",
    ft: "故障碼",
  },
  工程编号: {
    en: "Eng Pid",
    zh: "工程编号",
    ft: "工程編號",
  },
  "工程编码": {
    zh: '工程编码',
    ft: '工程編碼',
  },
  输入工程编号: {
    en: "Eng Pid",
    zh: "输入工程编号",
    ft: "輸入工程編號",
  },
  输入故障码: {
    en: "SDC Code",
    zh: "输入故障码",
    ft: "輸入故障碼",
  },
  零件号: {
    en: "OE number",
    zh: "零件号",
    ft: "零件號",
  },
  零件名称: {
    en: "Part Name",
    zh: "零件名称",
    ft: "零件名稱",
  },
  渠道价格: {
    en: "Price",
    zh: "渠道价格",
    ft: "渠道價格",
  },
  替换件: {
    en: "Supersession",
    zh: "替换件",
    ft: "替換件",
  },
  品牌件: {
    en: "Articles",
    zh: "品牌件",
    ft: "品牌件",
  },
  组件: {
    en: "Component",
    zh: "组件",
    ft: "組件",
  },
  技术信息: {
    en: "Technical Info",
    zh: "技术信息",
    ft: "技術信息",
  },
  适用车型: {
    en: "Applicable Veh",
    zh: "适用车型",
    ft: "適用車型",
  },
  输入配置信息: {
    en: "Search",
    zh: "输入配置信息",
    ft: "輸入配置信息",
  },

  //parteng
  品牌编号: {
    en: "Article Number",
    zh: "品牌编号",
    ft: "品牌編號",
  },
  原厂OE号: {
    en: "OE Number",
    zh: "原厂OE号",
    ft: "原廠OE號",
  },
  输入品牌编号: {
    en: "Article Number",
    zh: "输入品牌编号",
    ft: "輸入品牌編號",
  },
  输入原厂完整OE号: {
    en: "OE Number",
    zh: "输入原厂完整OE号",
    ft: "輸入原廠完整OE號",
  },
  品牌: {
    en: "brand",
    zh: "品牌",
    ft: "品牌",
  },
  问题反馈: {
    en: "Feedback",
    zh: "问题反馈",
    ft: "問題反饋",
  },
  反馈: {
    en: "Feedback",
    zh: "反馈",
    ft: "反饋",
  },
  "EA号:": {
    en: "EA number:",
    zh: "EA号:",
    ft: "EA號",
  },
  "包数:": {
    en: "Packages:",
    zh: "包数:",
    ft: "包數:",
  },
  "数量/每包:": {
    en: "Quantity/Package:",
    zh: "数量/每包:",
    ft: "數量/每包",
  },
  "描述:": {
    en: "Description",
    zh: "描述",
    ft: "描述",
  },
  "标签:": {
    en: "Label",
    zh: "标签:",
    ft: "標籤",
  },
  "零件详情": {
    en: "Detail",
    zh: "零件详情",
    ft: "零件詳情",
  },
  "替换件号:": {
    en: "Supersession",
    zh: "替换件号:",
    ft: "替換件號:",
  },
  基础信息: {
    en: "Basic",
    zh: "基础信息",
    ft: "基礎信息",
  },
  零件图片: {
    en: "Part Image",
    zh: "零件图片",
    ft: "零件圖片",
  },
  主: {
    en: "Maingroup",
    zh: "主",
    ft: "主",
  },
  分: {
    en: "Subgroup",
    zh: "分",
    ft: "分",
  },
  子: {
    en: "Semi-Subgroup",
    zh: "子",
    ft: "子",
  },
  "1  选择配置：": {
    en: "1 Configuration",
    zh: "1  选择配置：",
    ft: "1  選擇配置：",
  },
  "2  选择主组：": {
    en: "2 Maingroup",
    zh: "2  选择主组：",
    ft: "2  選擇主組：",
  },
  公司名称: {
    en: "Company",
    zh: "公司名称",
    ft: "公司名稱",
  },
  公司: {
    en: "Company",
    zh: "公司",
    ft: "公司",
  },
  位置: {
    zh: "位置",
    ft: "位置",
  },
  库存: {
    zh: "库存",
    ft: "庫存",
  },
  "输入图号/名称": {
    en: "ILLU No./Name",
    zh: "输入图号/名称",
    ft: "輸入圖號/名稱",
  },
  尝试车型查询: {
    en: "Try model query",
    zh: "尝试车型查询",
    ft: "嘗試車型查詢",
  },
  尝试选择品牌查询: {
    en: "select a brand and retry",
    zh: "尝试选择品牌查询",
    ft: "嘗試選擇品牌查詢",
  },
  清空: {
    en: "Empty cart",
    zh: "清空",
    ft: "清空",
  },
  报价: {
    en: "Bid",
    zh: "报价",
    ft: "報價",
  },
  "确认清空购物车？": {
    en: "Are your sure to empty cart?",
    zh: "确认清空购物车？",
    ft: "確認清空購物車？",
  },
  确认: {
    en: "Sure",
    zh: "确认",
    ft: "確認",
  },
  取消: {
    en: "Cancel",
    zh: "取消",
    ft: "取消",
  },
  导出Excel: {
    en: "Export to excel file",
    zh: "导出Excel",
    ft: "導出Excel",
  },
  合计: {
    en: "Sum up",
    zh: "合计",
    ft: "合計",
  },
  微信扫一扫分享报价单: {
    en: "Scan QR code to share quotation",
    zh: "微信扫一扫分享报价单",
    ft: "微信掃一掃分享報價單",
  },
  配件报价表: {
    en: "Parts quotation",
    zh: "配件报价表",
    ft: "配件報價表",
  },
  报价方资料: {
    en: "Buyer information",
    zh: "报价方资料",
    ft: "報價方資料",
  },
  联系人: {
    en: "Contacter",
    zh: "联系人",
    ft: "聯繫人",
  },
  联系电话: {
    en: "Phone",
    zh: "联系电话",
    ft: "聯繫電話",
  },
  备注: {
    en: "Remark",
    zh: "备注",
    ft: "備註",
  },
  "General 常规": {
    en: "General",
    zh: "General 常规",
    ft: "General 常規",
  },
  零件OE号: {
    en: "OE number",
    zh: "零件OE号",
    ft: "零件OE號",
  },
  品牌零件号: {
    en: "OE number",
    zh: "品牌零件号",
    ft: "品牌零件號",
  },
  厂商: {
    en: "Manufacturer",
    zh: "厂商",
    ft: "廠商",
  },
  显示全部: {
    en: "Show all",
    zh: "显示全部",
    ft: "顯示全部",
  },
  收起全部: {
    en: "Hide all",
    zh: "收起全部",
    ft: "收起全部",
  },
  详情: {
    en: "Detail",
    zh: "详情",
    ft: "詳情",
  },
  下一步: {
    en: "Next",
    zh: "下一步",
    ft: "下一步",
  },
  查看历史报价单: {
    en: "View the quotation history",
    zh: "查看历史报价单",
    ft: "查看歷史報價單",
  },
  "温馨提示：请检查您的输入是否正确": {
    en: "Please, ensure your entering is correct.",
    zh: "温馨提示：请检查您的输入是否正确",
    ft: "溫馨提示：請檢查您的輸入是否正確",
  },
  设备编号: {
    en: "Equiment No",
    zh: "设备编号",
    ft: "設備編號",
  },
  "*有效（+）：编码与车辆配置信息匹配则零件对车辆有效；": {
    en: "Valid(+): part is valid for vehicle if vehicle configuration info and code are matched",
    zh: "*有效（+）：编码与车辆配置信息匹配则零件对车辆有效；",
    ft: "*有效（+）：編碼與車輛配置信息匹配則零件對車輛有效：",
  },
  "无效（-）：编码与车辆配置信息匹配则零件对车辆无效；": {
    en: "part is invalid for vhicle if code cant match vehicle configuration. ",
    zh: "无效（-）：编码与车辆配置信息匹配则零件对车辆无效；",
    ft: "無效（-）：編碼與車輛配置信息匹配則零件對車輛無效：",
  },
  "：编码与车辆配置信息匹配。": {
    en: "part and vehicle configuration can match each other",
    zh: "：编码与车辆配置信息匹配。",
    ft: "：編碼與車輛配置信息匹配。",
  },
  参见: {
    en: "Refer",
    zh: "参见",
    ft: "參見",
  },
  选择零件组: {
    en: "Group",
    zh: "选择零件组",
    ft: "選擇零件組",
  },
  加载更多: {
    en: "LoadMore",
    zh: "加载更多",
    ft: "加載更多",
  },
  XXX: {
    en: "",
    zh: "XXX",
    ft: "XXX",
  },
  "服务正忙，请5秒后再试": {
    en: "Server are busy currently, please retry 5 seconds later!",
    zh: "服务正忙，请5秒后再试",
    ft: "服務正忙，請5秒後再試",
  },
  chooseMtc: {
    en: 'Select maintenance parts',
    zh: '保养套餐',
    ft: "保養套餐",
  },
  库存信息: {
    en: "Inventory",
    zh: "库存信息",
    ft: "庫存信息",
  },
  工作日: {
    en: "Working days",
    zh: "工作日",
    ft: "工作日",
  },
  inventoryTips: {
    en: "The above information is provided by the user, and 007vin does not provide any guarantee.",
    zh: "以上信息由用户提供，零零汽不提供任何担保。",
    ft: "以上信息由用戶提供，零零汽不提供任何擔保。",
  },
  sellerTips: {
    en: "A total of 0 dealers supply",
    zh: "共有 0 家经销商供货",
    ft: "共有 0 家經銷商供貨",
  },
  nosupplier: {
    en: "No supplier",
    zh: "暂无供应商",
    ft: "暫無供應商",
  },
  wantBuyPart: {
    en: "I want to buy this part",
    zh: "我想购买此零件",
    ft: "我想購買此零件",
  },
  showInventory: {
    en: "Show your inventory information here for more trading opportunities",
    zh: "在此展示您的库存信息，获取更多交易机会",
    ft: "在此展示您的庫存信息，獲取更多交易機會",
  },
  我想在此展示我的库存信息: {
    en: "I'd like to present my inventory information here",
    zh: "我想在此展示我的库存信息",
    ft: "我想在此展示我的庫存信息",
  },
  展开QQ: {
    en: "QQ",
    zh: "展开QQ",
    ft: "展開QQ",
  },
  展开电话: {
    en: "Phone",
    zh: "展开电话",
    ft: "展開電話",
  },
  展开微信: {
    en: "WeChat",
    zh: "展开微信",
    ft: "展開微信",
  },
  所有品牌: {
    en: "All brands",
    zh: "所有品牌",
    ft: "所有品牌",
  },
  简介: {
    en: "Introduction",
    zh: "简介",
    ft: "簡介",
  },
  人求购: {
    en: "Wanted",
    zh: "人求购",
    ft: "人求購",
  },
  求购: {
    en: "Wanted",
    zh: "求购",
    ft: "求購",
  },
  求购详情: {
    en: "Wanted detail",
    zh: "求购详情",
    ft: "求購詳情",
  },
  仓库地址: {
    en: "Warehouse",
    zh: "仓库地址",
    ft: "倉庫地址",
  },
  手机版: {
    en: 'Phone',
    zh: '手机版',
    ft: "手機版",
  },
  手机扫码: {
    en: 'Mobile phones and code',
    zh: '手机扫码',
    ft: '手機掃碼'
  },
  下载零零汽: {
    en: "Download 007vin",
    zh: "下载零零汽",
    ft: "下載零零汽"
  },
  分享: {
    en: 'Share',
    zh: '分享',
    ft: "分享",
  },
  零零汽首页: {
    en: 'Home',
    zh: '零零汽首页',
    ft: "零零汽首頁",
  },
  购物车: {
    en: 'Cart',
    zh: '购物车',
    ft: "購物車",
  },
  报价单: {
    en: 'Quotation',
    zh: '报价单',
    ft: "報價單",
  },
  询价单: {
    en: 'Enquiry',
    zh: '询价单',
    ft: "詢價單",
  },
  账户管理: {
    en: 'Account',
    zh: '账户管理',
    ft: "帳號管理",
  },
  购买续费: {
    en: 'Purchase',
    zh: '购买续费',
    ft: "購買續費",
  },
  消息中心: {
    en: 'Message',
    zh: '消息中心',
    ft: "消息中心",
  },
  退出: {
    en: 'LoginOut',
    zh: '退出',
    ft: "退出",
  },
  宝马: {
    en: 'BMW',
    zh: '宝马',
    ft: "寶馬",
  },
  奔驰: {
    en: 'Mercedes',
    zh: '奔驰',
    ft: "奔馳",
  },
  捷豹: {
    en: 'Jaguar',
    zh: '捷豹',
    ft: "捷豹",
  },
  路虎: {
    en: 'Land rover',
    zh: '路虎',
    ft: "路虎",
  },
  玛莎拉蒂: {
    en: 'Maserati',
    zh: '玛莎拉蒂',
    ft: "瑪莎拉蒂",
  },
  消息: {
    en: 'Message',
    zh: '消息',
    ft: "消息",
  },
  点击返回旧版: {
    en: 'Old Version',
    zh: '点击返回旧版',
    ft: "點擊返回舊版",
  },
  车型: {
    en: 'VIN',
    zh: '车型',
    ft: "車型",
  },
  选择保养套餐: {
    en: 'Maintenance Package',
    zh: '选择保养套餐',
    ft: "選擇保養套餐",
  },
  操作说明: {
    en: 'Instructions',
    zh: '操作说明',
    ft: "操作說明",
  },
  添加套餐: {
    en: 'Add Package',
    zh: '添加套餐',
    ft: "添加套餐",
  },
  编辑套餐: {
    en: 'Edit Package',
    zh: '编辑套餐',
    ft: "編輯套餐",
  },
  保存: {
    en: 'Save',
    zh: '保存',
    ft: "保存",
  },
  选择车架号: {
    en: 'Select VIN',
    zh: '选择车架号',
    ft: "選擇車架號",
  },
  选择配置信息: {
    en: 'Select configuration information',
    zh: '选择配置信息',
    ft: "選擇配置信息",
  },
  为您找到相关结果约0个: {
    en: 'Find the relevant results for you about 0',
    zh: '为您找到相关结果约0个',
    ft: "為您找到相關結果約0個",
  },
  为您找到相关结果约: {
    zh: '为您找到相关结果约',
    en: 'Find relevant results for you about',
    ft: '為您找到相關結果約',
  },
  个: {
    zh: '个',
    en: 'Pieces',
    ft: '個',
  },
  名称: {
    en: "Name",
    zh: "名称",
    ft: "名稱",
  },
  库存展示: {
    en: "Inventory show",
    zh: "库存展示",
    ft: "庫存展示",
  },
  所属品牌: {
    en: "brands",
    zh: "所属品牌",
    ft: "所屬品牌",
  },
  工序: {
    en: "Process",
    zh: "工序",
    ft: "工序",
  },
  编辑工序: {
    en: "Edit",
    zh: "编辑工序",
    ft: "編輯工序",
  },
  厂商筛选: {
    en: "Filter",
    zh: "厂商筛选",
    ft: "廠商篩選",
  },
  序号: {
    en: "Sequence",
    zh: "序号",
    ft: "序號",
  },
  零件: {
    en: "Part",
    zh: "零件",
    ft: "零件",
  },
  保养内容: {
    en: "Content",
    zh: "保养内容",
    ft: "保養內容",
  },
  装配件数: {
    en: "Assembly Number",
    zh: "装配件数",
    ft: "裝配件數",
  },
  型号: {
    en: "Model",
    zh: "型号",
    ft: "型號",
  },
  参考价格: {
    en: "Price",
    zh: "参考价格",
    ft: "參考價格",
  },
  操作: {
    en: "Operational",
    zh: "操作",
    ft: "操作",
  },
  查看更多: {
    en: "More",
    zh: "查看更多",
    ft: "查看更多",
  },
  还没有工序: {
    en: 'No Process Yet',
    zh: "还没有工序",
    ft: "還沒有工序",
  },
  "现在编辑，汽车专家就是你！": {
    en: "Edit now, the car expert is you!",
    zh: "现在编辑，汽车专家就是你！",
    ft: "現在編輯，汽車專家就是你！",
  },
  原厂工序: {
    zh: "原厂工序",
    en: "Original process",
    ft: "原廠工序",
  },
  我的工序: {
    zh: "我的工序",
    en: "My process",
    ft: "我的工序",
  },
  温馨提示: {
    zh: "温馨提示",
    en: "Tips",
    ft: "溫馨提示",
  },
  "是否保存正在编辑的内容？": {
    zh: "是否保存正在编辑的内容？",
    en: "Whether to save the content being edited?",
    ft: "是否保存正在編輯的內容？",
  },
  全: {
    zh: '全',
    en: 'all',
    ft: '全',
  },
  "选择品牌：": {
    zh: '选择品牌：',
    en: "Choose brand:",
    ft: "選擇品牌：",
  },
  "请输入搜索内容": {
    zh: "请输入搜索内容",
    en: "Enter search content",
    ft: "請輸入搜索內容",
  },
  件号: {
    zh: '件号',
    en: 'Part Number',
    ft: '件號',
  },
  数量: {
    zh: '数量',
    en: 'count',
    ft: '數量',
  },
  品: {
    zh: '品',
    en: 'P',
    ft: '品',
  },
  原: {
    zh: '原',
    en: 'O',
    ft: '原',
  },
  原厂搜索无结果: {
    zh: '原厂搜索无结果',
    en: 'No Results',
    ft: '原廠搜索無結果',
  },
  添加: {
    zh: '添加',
    en: 'Add',
    ft: '添加',
  },
  继续添加: {
    zh: '继续添加',
    en: 'Add Still',
    ft: '繼續添加',
  },
  输入零件号创建保养内容: {
    en: 'Enter part number to create maintenance content',
    zh: '输入零件号创建保养内容',
    ft: '輸入零件號創建保養內容',
  },
  暂无数据: {
    zh: '暂无数据',
    en: 'No Data',
    ft: '暫無數據',
  },
  原厂套餐: {
    zh: '原厂套餐',
    ft: '原廠套餐',
    en: 'Original package'
  },
  新建保养套餐: {
    zh: '新建保养套餐',
    ft: '新建保養套餐',
    en: 'New maintenance package'
  },
  编辑保养套餐: {
    zh: '编辑保养套餐',
    ft: '編輯保養套餐',
    en: 'Edit maintenance package'
  },
  套餐名字: {
    zh: '套餐名字',
    ft: '套餐名字',
    en: 'Package name'
  },
  "保养频次：": {
    zh: '保养频次：',
    ft: '保養頻次：',
    en: 'Maintenance frequency'
  },
  工时: {
    zh: '工时',
    ft: '工時',
    en: 'Working hours'
  },
  加注量: {
    zh: '加注量',
    ft: '加注量',
    en: 'Filling quantity'
  },
  工时单位: {
    zh: '工时单位',
    ft: '工時單位',
    en: 'Work units'
  },
  "原厂套餐价：": {
    zh: '原厂套餐价：',
    ft: '原廠套餐價：',
    en: 'Original set price：'
  },
  "我的套餐价": {
    zh: '我的套餐价',
    ft: '我的套餐價',
    en: 'My set meal price'
  },
  计算: {
    zh: '计算',
    ft: '計算',
    en: 'To calculate'
  },
  "折扣：": {
    zh: '折扣：',
    ft: '折扣：',
    en: 'Discount:'
  },
  "上传失败": {
    zh: '上传失败',
    ft: '上傳失敗',
    en: 'Upload failed'
  },
  "主组搜索": {
    zh: '主组搜索',
    ft: '主組搜索',
    en: 'The main group search'
  },
  "选择国家": {
    zh: '选择国家',
    ft: '選擇國家',
    en: 'Choose the country'
  },
  "返回": {
    zh: '返回',
    ft: '返回',
    en: 'return'
  },
  "列表": {
    zh: '列表',
    ft: '列表',
    en: 'The list of'
  },
  "图片": {
    zh: '图片',
    ft: '圖片',
    en: 'The picture'
  },
  "切换到列表": {
    zh: '切换到列表',
    ft: '切換到列表',
    en: "Let's go to the list"
  },
  "切换到图片": {
    zh: '切换到图片',
    ft: '切換到圖片',
    en: "Let's go to the image"
  },
  "请输入配置信息": {
    zh: '请输入配置信息',
    ft: '請輸入配置信息',
    en: 'Please enter configuration information'
  },
  "切换过滤状态": {
    zh: '切换过滤状态',
    ft: '切換過濾狀態',
    en: 'Switched filter state'
  },
  "免责声明：查询结果仅供参考。": {
    zh: '免责声明：查询结果仅供参考。',
    ft: '免責聲明：查詢結果僅供參考。',
    en: 'Disclaimer: query results are for reference only.'
  },
  "零件不适用此车型": {
    zh: '零件不适用此车型',
    ft: '零件不適用此車型',
    en: 'The parts are not suitable for this model'
  },
  "鼠标移至数据框内，可编辑": {
    zh: '鼠标移至数据框内，可编辑',
    ft: '鼠標移至數據框內，可編輯',
    en: 'Mouse over the data box, editable'
  },
  "原厂名称：": {
    zh: '原厂名称：',
    ft: '原廠名稱：',
    en: 'Name of original factory:'
  },
  "件数": {
    zh: '件数',
    ft: '件數',
    en: 'number'
  },
  "说明": {
    zh: '说明',
    en: 'instructions',
    ft: '說明',
  },
  "我的库存:": {
    zh: '我的库存:',
    ft: '我的庫存:',
    en: 'My inventory:'
  },
  "供应商有货": {
    zh: '供应商有货',
    ft: '供應商有貨',
    en: 'Supplier in stock'
  },
  "去找货": {
    zh: '去找货',
    ft: '去找貨',
    en: 'To find the goods'
  },
  "上分组": {
    zh: '上分组',
    ft: '上分組',
    en: 'On the group'
  },
  "下分组": {
    zh: '下分组',
    ft: '下分組',
    en: 'Under the group'
  },
  "绿色字体：规格条件过滤（表示可选）": {
    zh: '绿色字体：规格条件过滤（表示可选）',
    ft: '綠色字體：規格條件過濾（表示可選）',
    en: 'Green font: specification condition filtering (optional)'
  },
  "输入零件原厂名／零件号": {
    zh: '输入零件原厂名／零件号',
    ft: '輸入零件原廠名/零件號',
    en: 'Enter part name/part number'
  },
  "原厂结构": {
    zh: '原厂结构',
    ft: '原廠結構',
    en: 'Original structure'
  },
  "标准结构": {
    zh: '标准结构',
    ft: '標準結構',
    en: 'Standard structure'
  },
  "反馈成功": {
    zh: '反馈成功',
    ft: '反饋成功',
    en: 'Feedback success'
  },
  "已有": {
    zh: '已有',
    ft: '已有',
    en: 'existing'
  },
  "种零件有供应商": {
    zh: '种零件有供应商',
    ft: '種零件有供應商',
    en: 'We have suppliers for all kinds of parts'
  },
  "暂无供应商": {
    zh: '暂无供应商',
    ft: '暫無供應商',
    en: 'No supplier yet'
  },
  "前往购买": {
    zh: '前往购买',
    ft: '前往購買',
    en: 'Go to buy'
  },
  "询价": {
    zh: '询价',
    ft: '詢價',
    en: 'Make an inquiry'
  },
  "评级": {
    zh: '评级',
    ft: '評級',
    en: 'The rating'
  },
  "共": {
    zh: '共',
    ft: '共',
    en: 'A total of'
  },
  "家有货": {
    zh: '家有货',
    ft: '家有貨',
    en: 'The home is available'
  },
  "查看全部": {
    zh: '查看全部',
    ft: '查看全部',
    en: 'All'
  },
  "公司简介": {
    zh: '公司简介',
    ft: '公司簡介',
    en: 'Company profile'
  },
  "零件供应商": {
    zh: '零件供应商',
    ft: '零件供應商',
    en: 'Parts supplier'
  },
  "家零件供应商": {
    zh: '家零件供应商',
    ft: '家零件供應商',
    en: 'Home parts supplier'
  },
  "有": {
    zh: '有',
    ft: '有',
    en: 'There are'
  },
  "电话号码": {
    zh: '电话号码',
    ft: '電話號碼',
    en: 'The phone number'
  },
  "点击前往零件号间隔设置页面": {
    zh: '点击前往零件号间隔设置页面',
    ft: '點擊前往零件號間隔設置頁面',
    en: 'Click to go to the part number interval Settings page'
  },
  "请输入零件号查询，多零件请换行": {
    zh: "请输入零件号查询，多零件请换行",
    ft: "請輸入零件號查詢，多零件請換行",
    en: 'Please enter the part number query, multi-part please newline'
  },
  "零件查询结果列表": {
    zh: '零件查询结果列表',
    en: 'List of parts query results',
    ft: '零件查詢結果列表',
  },
  "未查询到结果，你可查看以下相似结果": {
    zh: '未查询到结果，你可查看以下相似结果',
    en: 'No query results, you can view the following similar results',
    ft: '未查詢到結果，妳可查看以下相似結果',
  },
  "未匹配到任何零件": {
    zh: '未匹配到任何零件',
    en: 'No parts were matched',
    ft: '未匹配到任何零件',
  },
  "立即反馈": {
    zh: '立即反馈',
    en: 'Immediate feedback',
    ft: '立即反馈',
  },
  "相似结果": {
    zh: '相似结果',
    en: 'Similar results',
    ft: '相似結果',
  },
  "未匹配到结果": {
    zh: '未匹配到结果',
    en: 'The result was not matched',
    ft: '未匹配到結果',
  },
  "适用于以下品牌": {
    zh: '适用于以下品牌',
    en: 'Applicable to the following brands',
    ft: '適用於以下品牌',
  },
  "渠道价格（含税）": {
    zh: '渠道价格（含税）',
    en: 'Channel price (tax included)',
    ft: '渠道價格（含稅）',
  },
  "请输入零件号": {
    zh: '请输入零件号',
    en: 'Please enter the part number',
    ft: '請輸入零件號',
  },
  "至少输入5个字符": {
    zh: '至少输入5个字符',
    en: 'Enter at least 5 characters',
    ft: '至少輸入5個字符',
  },
  "最多支持50个零件号同时查询": {
    zh: '最多支持50个零件号同时查询',
    en: 'Supports up to 50 part Numbers simultaneously',
    ft: '最多支持50個零件號同時查詢',
  },
  "零件类型": {
    zh: '零件类型',
    en: 'Component type',
    ft: '零件類型',
  },
  "进价(未含税)": {
    zh: '进价(未含税)',
    en: 'Purchase price (excluding tax)',
    ft: '進價(未含稅)',
  },
  "进价(含税)": {
    zh: '进价(含税)',
    en: 'Purchase price (including tax)',
    ft: '進價(含稅)',
  },
  "销售价(含税)": {
    zh: '销售价(含税)',
    en: 'Sales price (including tax)',
    ft: '銷售價(含稅)',
  },
  "服务商": {
    zh: '服务商',
    en: 'Service providers',
    ft: '服務商',
  },
  "销售价": {
    zh: '销售价',
    en: 'Sales price',
    ft: '銷售價',
  },
  "注释": {
    zh: '注释',
    en: 'annotation',
    ft: '註釋',
  },
  "年份": {
    zh: '年份',
    en: 'year',
    ft: '年份',
  },
  "市场": {
    zh: '市场',
    en: 'market',
    ft: '市場',
  },
  "品牌图片": {
    zh: '品牌图片',
    en: 'The brand image',
    ft: '品牌圖片',
  },
  "更新时间": {
    zh: '更新时间',
    en: 'Update time',
    ft: '更新時間',
  },
  "当前查询零件": {
    zh: '当前查询零件',
    en: 'Current query parts',
    ft: '當前查詢零件',
  },
  "看不懂请点我": {
    zh: '看不懂请点我',
    en: 'Please click me',
    ft: '看不懂請點我',
  },
  "最新": {
    zh: '最新',
    en: 'The latest',
    ft: '最新',
  },
  "直接替换": {
    zh: '直接替换',
    en: 'Direct replacement',
    ft: '直接替換',
  },
  "从旧到新排序": {
    zh: '从旧到新排序',
    en: 'Sort from old to new',
    ft: '從舊到新排序',
  },
  "从新到旧排序": {
    zh: '从新到旧排序',
    en: 'New sort to old sort',
    ft: '從新到舊排序',
  },
  "间接替换": {
    zh: '间接替换',
    en: 'Indirect replacement',
    ft: '間接替換',
  },
  "当前位置": {
    zh: '当前位置',
    en: 'The current position',
    ft: '當前位置',
  },
  "品牌详情": {
    zh: '品牌详情',
    en: 'Details of the brand',
    ft: '品牌詳情',
  },
  "图片来自官方，仅供参考": {
    zh: '图片来自官方，仅供参考',
    en: 'The picture is from the official, for reference only',
    ft: '圖片來自官方，僅供參考',
  },
  "丰田": {
    zh: '丰田',
    en: 'toyota',
    ft: '豐田',
  },
  "雷克萨斯": {
    zh: '雷克萨斯',
    en: 'lexus',
    ft: '雷克薩斯',
  },
  "福特": {
    zh: '福特',
    en: 'ford',
    ft: '福特',
  },
  "本田": {
    zh: '本田',
    en: 'honda',
    ft: '本田',
  },
  "讴歌": {
    zh: '讴歌',
    en: 'acura',
    ft: '謳歌',
  },
  "尼桑": {
    zh: '尼桑',
    en: 'nissan',
    ft: '尼桑',
  },
  "三菱": {
    zh: '三菱',
    en: 'mitsubishi',
    ft: '三菱',
  },
  "输入宝马后7位VIN车架号": {
    zh: '输入宝马后7位VIN车架号',
    en: 'Enter the VIN frame number of BMW after 7 digits',
    ft: '輸入寶馬後7位VIN車架號',
  },
  "输入MINI后7位VIN车架号": {
    zh: '输入MINI后7位VIN车架号',
    en: 'Enter the VIN frame number of 7 digits after MINI',
    ft: '輸入MINI後7位VIN車架號',
  },
  "输入奔驰后8位VIN车架号": {
    zh: '输入奔驰后8位VIN车架号',
    en: 'Enter the 8-bit VIN frame number after Benz',
    ft: '輸入奔馳後8位VIN車架號',
  },
  "输入Smart后8位VIN车架号": {
    zh: '输入Smart后8位VIN车架号',
    en: 'Enter Smart 8-bit VIN frame number',
    ft: '輸入Smart後8位VIN車架號',
  },
  "输入捷豹后7位VIN车架号": {
    zh: '输入捷豹后7位VIN车架号',
    en: 'Enter the 7-bit VIN frame number after the jaguars',
    ft: '輸入捷豹後7位VIN車架號',
  },
  "输入路虎后8位VIN车架号": {
    zh: '输入路虎后8位VIN车架号',
    en: 'Enter the VIN frame number of the last 8 digits of land rover',
    ft: '輸入路虎後8位VIN車架號',
  },
  "输入玛莎拉蒂后7位VIN车架号": {
    zh: '输入玛莎拉蒂后7位VIN车架号',
    en: 'Input the VIN frame number of 7 digits after maserati',
    ft: '輸入瑪莎拉蒂後7位VIN車架號',
  },
  "输入丰田后13位VIN车架号": {
    zh: '输入丰田后13位VIN车架号',
    en: 'Enter the VIN frame number of the 13 digits after Toyota',
    ft: '輸入豐田後13位VIN車架號',
  },
  "输入雷克萨斯后13位VIN车架号": {
    zh: '输入雷克萨斯后13位VIN车架号',
    en: 'Enter the 13-bit VIN frame number after lexus',
    ft: '輸入雷克薩斯後13位VIN車架號',
  },
  "输入福特后11位VIN车架号": {
    zh: '输入福特后11位VIN车架号',
    en: 'Enter the 11-digit VIN frame number after ford',
    ft: '輸入福特後11位VIN車架號',
  },
  "输入尼桑后11位VIN车架号": {
    zh: '输入福特后11位VIN车架号',
    en: 'Enter the 11-bit VIN frame number after nissan',
    ft: '輸入尼桑後11位VIN車架號',
  },
  "输入三菱后11位VIN车架号": {
    zh: '输入三菱后11位VIN车架号',
    en: 'Enter the VIN frame number of 11 digits after mitsubishi',
    ft: '輸入三菱後11位VIN車架號',
  },
  "请输入17位车架号": {
    zh: '请输入17位车架号',
    en: 'Please enter 17 bit frame number',
    ft: '請輸入17位車架號',
  },
  "请输入8或17位车架号": {
    zh: '请输入8或17位车架号',
    en: 'Please enter 8 or 17 bit frame number',
    ft: '請輸入8或17位車架號',
  },
  "请输入7或17位车架号": {
    zh: '请输入7或17位车架号',
    en: 'Please enter 7 or 17 bit frame number',
    ft: '請輸入7或17位車架號',
  },
  "请输入11或17位车架号": {
    zh: '请输入11或17位车架号',
    en: 'Please enter 11 or 17 bit frame number',
    ft: '請輸入11或17位車架號',
  },
  "请输入13或17位车架号": {
    zh: '请输入13或17位车架号',
    en: 'Please enter 13 or 17 bit frame number',
    ft: '請輸入13或17位車架號',
  },
  "配置详情": {
    zh: '配置详情',
    en: 'Configuration details',
    ft: '配置詳情',
  },
  "品牌选择": {
    zh: '品牌选择',
    en: 'Brand',
    ft: '品牌選擇',
  },
  "分类选择": {
    zh: '分类选择',
    en: 'Classification',
    ft: '分類選擇',
  },
  "未找到结果": {
    zh: '未找到结果',
    en: 'No result found',
    ft: '未找到結果',
  },
  "未找到": {
    zh: '未找到',
    en: 'No found',
    ft: '未找到',
  },
  "您可查看相似结果": {
    zh: '您可查看相似结果',
    en: 'You can view similar results',
    ft: '您可查看相似結果',
  },
  "为你找到以下结果": {
    zh: '为你找到以下结果',
    en: 'Find the following results for you',
    ft: '為妳找到以下結果',
  },
  "品牌筛选": {
    zh: '品牌筛选',
    en: 'Brand filter',
    ft: '品牌篩選',
  },
  "筛选": {
    zh: '筛选',
    en: 'screening',
    ft: '篩選',
  },
  "品类筛选": {
    zh: '品类筛选',
    en: 'Category selection',
    ft: '品類篩選',
  },
  "品名筛选": {
    zh: '品名筛选',
    en: 'Commodity screening',
    ft: '品名篩選',
  },
  "产地筛选": {
    zh: '产地筛选',
    en: 'Screening of origin',
    ft: '產地篩選',
  },
  "没有查询权限，如需使用，请按以下联系方式寻求帮助": {
    zh: '没有查询权限，如需使用，请按以下联系方式寻求帮助',
    en: '',
    ft: '如果沒有查詢權限，如需使用，請按以下聯繫方式尋求幫助',
  },
  "台湾地区可联系": {
    zh: '台湾地区可联系',
    en: 'Taiwan can be contacted',
    ft: '台灣地區可聯繫',
  },
  "全选": {
    zh: '全选',
    en: 'Future generations',
    ft: '全選',
  },
  "单价": {
    zh: '单价',
    en: 'The unit price',
    ft: '單價',
  },
  "添加零件": {
    zh: '添加零件',
    en: 'Add the parts',
    ft: '添加零件',
  },
  "种": {
    zh: '种',
    en: 'Kind',
    ft: '種',
  },
  "件": {
    zh: '件',
    en: 'number',
    ft: '件',
  },
  "合计": {
    zh: '合计',
    en: 'total',
    ft: '合計',
  },
  "分享时隐藏零件oe号": {
    zh: '分享时隐藏零件oe号',
    en: 'Hide part oe number when sharing',
    ft: '分享時隱藏零件oe號',
  },
  "提交报价单": {
    zh: '提交报价单',
    en: 'Submit quotation',
    ft: '提交報價單',
  },
  "采购类型": {
    zh: '采购类型',
    en: 'Procurement type',
    ft: '采購類型',
  },
  "报价方": {
    zh: '报价方',
    en: 'quoted',
    ft: '報價方',
  },
  "报价时间": {
    zh: '报价时间',
    en: 'Offer the time',
    ft: '報價時間',
  },
  "报价单详情": {
    zh: '报价单详情',
    en: 'Quotation details',
    ft: '報價單詳情',
  },
  "复制链接后发送给对方，对方即可查看报价单": {
    zh: '复制链接后发送给对方，对方即可查看报价单',
    en: 'Copy the link and send it to the other party, who can view the quotation',
    ft: '復制鏈接後發送給對方，對方即可查看報價單',
  },
  "复制链接": {
    zh: '复制链接',
    en: 'Copy the link',
    ft: '復制鏈接',
  },
  "编号": {
    zh: '编号',
    en: 'Serial number',
    ft: '編號',
  },
  "代理商": {
    zh: '代理商',
    en: 'The agent',
    ft: '代理商',
  },
  "如需展示您的信息，请联系我们": {
    zh: '如需展示您的信息，请联系我们',
    en: 'To display your information, please contact us',
    ft: '如需展示您的信息，請聯系我們',
  },
  "台湾地区": {
    zh: '台湾地区',
    en: 'The Taiwan region',
    ft: '台灣地區',
  },
  "座机": {
    zh: '座机',
    en: 'landline',
    ft: '座機',
  },
  "其他地区": {
    zh: '其他地区',
    en: 'In other parts of the',
    ft: '其他地區',
  },
  "供应商": {
    zh: '供应商',
    en: 'supplier',
    ft: '供應商',
  },
  "选择问题": {
    zh: '选择问题',
    en: 'Selection problem',
    ft: '選擇問題',
  },
  "车架号查不到": {
    zh: '车架号查不到',
    en: 'Frame number not available',
    ft: '車架號查不到',
  },
  "零件号查不到": {
    zh: '零件号查不到',
    en: 'The part number cannot be found',
    ft: '零件號查不到',
  },
  "缺少车型": {
    zh: '缺少车型',
    en: 'The lack of models',
    ft: '缺少車型',
  },
  "数据不全": {
    zh: '数据不全',
    en: 'The data is not complete',
    ft: '數據不全',
  },
  "数据错误": {
    zh: '数据错误',
    en: 'Data error',
    ft: '數據錯誤',
  },
  "数据不够新": {
    zh: '数据不够新',
    en: 'The data is not new enough',
    ft: '數據不夠新',
  },
  "速度慢": {
    zh: '速度慢',
    en: 'Slow speed',
    ft: '速度慢',
  },
  "没有唯一性": {
    zh: '没有唯一性',
    en: 'No uniqueness',
    ft: '沒有唯一性',
  },
  "其他": {
    zh: '其他',
    en: 'other',
    ft: '其他',
  },
  "输入内容": {
    zh: '输入内容',
    en: 'The input',
    ft: '輸入內容',
  },
  "插入矩形": {
    zh: '插入矩形',
    en: 'rectangular',
    ft: '插入矩形',
  },
  "插入椭圆": {
    zh: '插入椭圆',
    en: 'ellipse',
    ft: '插入橢圓',
  },
  "插入箭头": {
    zh: '插入箭头',
    en: 'arrow',
    ft: '插入箭頭',
  },
  "插入文字": {
    zh: '插入文字',
    en: 'text',
    ft: '插入文字',
  },
  "感谢反馈": {
    zh: '感谢反馈',
    en: 'Thanks for the feedback',
    ft: '感謝反饋',
  },
  "我们将尽快处理": {
    zh: '我们将尽快处理',
    en: 'We will deal with it as soon as possible',
    ft: '我們將儘快處理',
  },
  "超过3万家配件商、修理厂、4S店使用零零汽": {
    zh: '超过3万家配件商、修理厂、4S店使用零零汽',
    en: '007vin is used by more than 30,000 accessories dealers, repair shops and 4S stores',
    ft: '超過3萬家配件商、修理廠、4S店使用零零汽'
  },
  "让配件查询更简单": {
    zh: "让配件查询更简单",
    en: "Make querying accessories easier",
    ft: "讓配件查詢更簡單"
  },
  "专业的汽配查询工具,随时随地上网就查": {
    zh: "专业的汽配查询工具,随时随地上网就查",
    en: "Professional auto parts query tools, anytime and anywhere on the Internet",
    ft: "專業的汽配查詢工具，隨時隨地上網就查"
  },
  "通过车架号，查询与原厂一致的车辆配置表和零件分组,支持超过500万的零件名、零件号搜索,让配件查询更简单": {
    zh: "通过车架号，查询与原厂一致的车辆配置表和零件分组,支持超过500万的零件名、零件号搜索,让配件查询更简单",
    en: "Through the frame number, the same as the original vehicle configuration table and parts group query, support more than 5 million parts name, part number search, make the parts query easier",
    ft: "通過車架號，查詢與原廠一直的車輛配置表和零件分組，支持超過500萬的零件名、零件號搜索，讓配件查詢更簡單"
  },
  "服务内容": {
    zh: "服务内容",
    en: "The service content",
    ft: "服務內容"
  },
  "解析车架号": {
    zh: "解析车架号",
    en: "Resolve frame number",
    ft: "解析車架號"
  },
  "精准匹配零件": {
    zh: "精准匹配零件",
    en: "Precisely matched parts",
    ft: "精準匹配零件"
  },
  "选择车型信息": {
    zh: "选择车型信息",
    en: "Select model information",
    ft: "選擇車型信息"
  },
  "备货从此更简单": {
    zh: "备货从此更简单",
    en: "Getting things ready will be easier",
    ft: "備貨從此更簡單"
  },
  "价格、替换件信息": {
    zh: "价格、替换件信息",
    en: "Price, replacement parts information",
    ft: "價格、替換件信息"
  },
  "持续更新上线": {
    zh: "持续更新上线",
    en: "Continuously update online",
    ft: "持續更新上線"
  },
  "国内外知名品牌厂商": {
    zh: "国内外知名品牌厂商",
    en: "Famous brand manufacturers at home and abroad",
    ft: "國內外知名品牌廠商"
  },
  "百万品牌零件搜索": {
    zh: "百万品牌零件搜索",
    en: "Million brand parts search",
    ft: "百萬品牌零件搜索"
  },
  "保养套餐、工时价格": {
    zh: "保养套餐、工时价格",
    en: "Maintenance package, working hour price",
    ft: "保養套餐、工時價格"
  },
  "修理厂更加专业": {
    zh: "修理厂更加专业",
    en: "Repair shops are more professional",
    ft: "修理廠更加專業"
  },
  "优势品牌展示": {
    zh: "优势品牌展示",
    en: "Display of dominant brands",
    ft: "優勢品牌展示"
  },
  "主要品牌展示": {
    zh: "主要品牌展示",
    en: "Display of major brands",
    ft: "主要品牌展示"
  },
  "更多": {
    en: "More",
    zh: "更多",
    ft: "更多",
  },
  "零零汽数据": {
    zh: "零零汽数据",
    en: "007VIN",
    ft: "零零汽數據"
  },
  "零零汽品牌配件数据": {
    zh: "零零汽品牌配件数据",
    en: "007Vin brand accessories data",
    ft: "零零汽品牌配件數據"
  },
  "本网站信息仅供参考": {
    zh: "本网站信息仅供参考",
    en: "This website information is for reference only",
    ft: "本網站信息僅供參考"
  },
  "客服电话：0571-8717 6177（周一至周五 09:30-17:30）": {
    zh: "客服电话：0571-8717 6177（周一至周五 09:30-17:30）",
    en: "Customer service tel: 0571-8717 6177 (Monday to Friday 09:30-17:30)",
    ft: "客服電話：0571-8717 6177（週一至週五 09:30-17:30）"
  },
  "扫一扫": {
    zh: "扫一扫",
    en: "scan",
    ft: "掃一掃"
  },
  "下载手机版": {
    zh: "下载手机版",
    en: "Download Phone",
    ft: "下載手機版"
  },
  "快速搜索": {
    zh: "快速搜索",
    en: "Quick search",
    ft: "快速搜索"
  },
  "输入主组名称": {
    zh: "输入主组名称",
    en: "Enter the name of the primary group",
    ft: "輸入主組名稱"
  },
  "新密码（6位以上数字或字母）": {
    zh: "新密码（6位以上数字或字母）",
    en: "New password (6 digits or more)",
    ft: "新密碼（6位以上數字或字母）"
  },
  "确认密码（6位以上数字或字母）": {
    zh: "确认密码（6位以上数字或字母）",
    en: "Confirm password (6 digits or more)",
    ft: "確認密碼（6位以上數字或字母）"
  },
  "手机验证修改密码": {
    zh: "手机验证修改密码",
    en: "Changes the password",
    ft: "手機驗證修改密碼"
  },
  "第三方账号登录": {
    zh: "第三方账号登录",
    en: "Third-party account login",
    ft: "第三方賬號登錄"
  },
  "微信账号登录": {
    zh: "微信账号登录",
    en: "WeChat login",
    ft: "微信賬號登錄"
  },
  "密码登录": {
    zh: "密码登录",
    en: "Password to login",
    ft: "密碼登錄"
  },
  "绑定手机": {
    zh: "绑定手机",
    en: "Binding mobile phone",
    ft: "綁定手機"
  }
  
}
// 根据具体的数值获取具体的语言文本
function lg(key) {
  if (lgDir[key]) {
    return lgDir[key][lge] || key;
  }
  return key;
}
// 改变语言
function changeLg(language) {
  lge = language;
}

export {
  lge,
  lg,
  changeLg
}
